// The backend refuses every route of a disabled company with a 403 carrying this header. It is not a lost
// login, so it must be told apart from a regular 403, which sends the user to the login page.
export const COMPANY_DISABLED_HEADER = 'X-Company-Disabled';

let handling = false;

export function isCompanyDisabledResponse(response: Response | null | undefined): boolean {
  return Boolean(response?.headers?.get(COMPANY_DISABLED_HEADER));
}

// A company that is disabled while in use: start over from the root, which picks a company that is still
// active. Guarded so concurrent failures navigate only once.
export function handleCompanyDisabled(): void {
  if (handling) {
    return;
  }
  handling = true;
  window.location.assign('/');
}
